// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("src/styles/logo-blue-32x32.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
.osjs-root {
  line-height: 1;
  font-size: 13px;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  touch-action: none;
}
.osjs-root[data-dir=rtl] {
  direction: rtl;
}
.osjs-root textarea,
.osjs-root input,
.osjs-root label {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
.osjs-root[data-mousemove=true] iframe {
  pointer-events: none;
}

.osjs-boot-splash-grid {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999999999;
  background-color: rgba(255, 255, 255, 0.84);
  height: 100%;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.osjs-boot-splash {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  z-index: 9999999999;
  flex-direction: column;
}

.osjs-boot-splash-fullscreen {
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  z-index: 9999999999;
  background-color: rgba(255, 255, 255, 0.84);
  height: 100vh;
  width: 100vw;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.osjs-boot-splash_message {
  font-size: 20px;
  color: black;
  margin-bottom: 3rem;
}

.osjs-mask-application {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999999999;
  background-color: rgba(255, 255, 255, 0.5);
  height: 100%;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.osjs-contents {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.osjs-profile-info-popup .profile-info-popup {
  width: 280px;
  z-index: 30000 !important;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
}
.osjs-profile-info-popup .profile-info-popup .k-popup {
  border: none;
}
.osjs-profile-info-popup .profile-info-popup .text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.osjs-profile-info-popup .profile-info-popup .close-icon {
  margin: 10px 15px 0px;
  display: flex;
  height: 20px;
  width: 20px;
  cursor: pointer;
  align-items: center;
  margin-left: auto;
  border-radius: 50%;
  justify-content: center;
}
.osjs-profile-info-popup .profile-info-popup .close-icon:hover {
  background-color: #f0f0f0;
}
.osjs-profile-info-popup .profile-info-popup .profile-img-container {
  align-items: center;
  display: flex;
  margin-bottom: 12px;
  justify-content: center;
}
.osjs-profile-info-popup .profile-info-popup .profile-img-container .profile-img {
  height: 120px;
  width: 120px;
  border-radius: 50%;
}
.osjs-profile-info-popup .profile-info-popup .profile-img-container .profile-icon {
  background-color: #E9EBEC;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  align-items: center;
  display: flex;
  justify-content: center;
}
.osjs-profile-info-popup .profile-info-popup .profile-img-container .profile-icon .icon {
  font-size: 80px;
  color: #B8BFC1;
}
.osjs-profile-info-popup .profile-info-popup .profile-content {
  background-color: #275362;
  color: white;
}
.osjs-profile-info-popup .profile-info-popup .profile-content .name {
  font-size: 22px;
  text-align: center;
  line-height: 35px;
}
.osjs-profile-info-popup .profile-info-popup .profile-content .designation {
  text-align: center;
  line-height: 25px;
}
.osjs-profile-info-popup .profile-info-popup .profile-content .chat-mail-link {
  height: 60px;
  align-items: center;
  display: flex;
  justify-content: center;
}
.osjs-profile-info-popup .profile-info-popup .profile-content .chat-mail-link .link-container {
  height: 40px;
  margin: 5px;
  cursor: pointer;
  width: 40px;
  background-color: #efefef;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  display: flex;
}
.osjs-profile-info-popup .profile-info-popup .profile-content .other-info {
  line-height: 30px;
}
.osjs-profile-info-popup .profile-info-popup .profile-content .other-info i {
  margin-right: 6px;
}

/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
.osjs-window-behavior-lofi {
  position: absolute;
  border: 2px solid #000;
}

.osjs-window-resize {
  z-index: 10;
  position: absolute;
  min-width: 4px;
  min-height: 0.1em;
}
.osjs-window-resize[data-direction^=n] {
  top: -0.5em;
}
.osjs-window-resize[data-direction^=s] {
  bottom: -0.5em;
}
.osjs-window-resize[data-direction\$=w] {
  left: -0.5em;
}
.osjs-window-resize[data-direction\$=e] {
  right: -0.5em;
}
.osjs-window-resize[data-direction=nw] {
  cursor: nw-resize;
}
.osjs-window-resize[data-direction=sw] {
  cursor: sw-resize;
}
.osjs-window-resize[data-direction=ne] {
  cursor: ne-resize;
}
.osjs-window-resize[data-direction=se] {
  cursor: se-resize;
}
.osjs-window-resize[data-direction=n] {
  cursor: n-resize;
}
.osjs-window-resize[data-direction=s] {
  cursor: s-resize;
}
.osjs-window-resize[data-direction=w] {
  cursor: w-resize;
}
.osjs-window-resize[data-direction=e] {
  cursor: e-resize;
}
.osjs-window-resize[data-direction=s], .osjs-window-resize[data-direction=n] {
  left: 0.5em;
  right: 0.5em;
}
.osjs-window-resize[data-direction=e], .osjs-window-resize[data-direction=w] {
  top: 0.5em;
  bottom: 0.5em;
}

.osjs-window-inner {
  position: relative;
  z-index: 1;
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
}

.osjs-window-header {
  display: flex;
  position: relative;
  box-sizing: border-box;
  flex: 0 0;
  min-height: 2.2em;
}
.osjs-window-header > div {
  height: auto;
  padding: 0px 5px 0px 5px;
}

.osjs-window-icon > div {
  width: 1em;
  height: 1em;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%;
  background-size: cover;
  cursor: pointer;
}

.osjs-window-title {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
}

.osjs-window-manage-buttons {
  display: flex;
  margin-right: 3px;
}

.osjs-window-button {
  cursor: pointer;
  min-width: 1em;
  position: relative;
  flex-basis: 1em;
}
.osjs-window-button * {
  pointer-events: none;
}
.osjs-window-button > div {
  width: 1em;
  height: 1em;
}
.osjs-window-button:not(:last-child) {
  margin-right: 0.25em;
}

.osjs-root[data-dir=rtl] .osjs-window-button:not(:last-child) {
  margin-right: 0;
  margin-left: 0.25em;
}

.osjs-window-content {
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  overflow: hidden;
  width: 100%;
  height: 100%;
  max-width: 100%;
  flex: 1 1;
  user-select: text;
}

.osjs-window {
  position: absolute;
  box-sizing: border-box;
  user-select: none;
  visibility: visible;
  touch-action: none;
  /* This actually increases performance */
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  perspective: 1000;
}
.osjs-window::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999999999;
  display: none;
}
.osjs-window[data-maximized=true] {
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
}
.osjs-window[data-maximized=true] .osjs-window-resize {
  cursor: inherit !important;
}
.osjs-window[data-minimized=true] {
  display: none;
  visibility: hidden;
  height: 560px !important;
}
.osjs-window[data-focused=false] iframe {
  pointer-events: none;
}
.osjs-window[data-resizing=true], .osjs-window[data-moving=true] {
  cursor: move;
}
.osjs-window[data-loading=true]::after {
  display: block;
}
.osjs-window.osjs__drop {
  outline: 2px solid #000;
}
.osjs-window[data-minimizable=false] .osjs-window-button[data-action=minimize], .osjs-window[data-maximizable=false] .osjs-window-button[data-action=maximize], .osjs-window[data-closable=false] .osjs-window-button[data-action=close], .osjs-window[data-resizable=false] .osjs-window-resize {
  display: none;
}

.osjs-root[data-window-action=true] .osjs-window {
  /* FIXME: Maybe limit this as to increase perf ? */
}
.osjs-root[data-window-action=true] .osjs-window * {
  pointer-events: none;
}

.osjs-root[data-mobile=true] .osjs-window {
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  opacity: 1;
}
.osjs-root[data-mobile=true] .osjs-window .osjs-window-button[data-action=maximize] {
  display: none;
}

/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
.osjs-notifications {
  position: absolute;
  top: 0;
  right: 0;
  pointer-events: none;
  box-sizing: border-box;
  padding: 1em;
  height: 100%;
  max-height: 100%;
  z-index: 16777272;
}

.osjs-notification {
  padding: 1em;
  box-sizing: border-box;
  pointer-events: all;
  min-width: 200px;
  margin-bottom: 1em;
}

.osjs-notification-wrapper {
  background-size: 3em;
  background-repeat: no-repeat;
}
.osjs-notification-wrapper[data-has-icon=true] {
  padding-left: calc(3em + 1em);
}

/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
.osjs-login {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 99999;
  transform: translate(-50%, -50%);
  display: flex;
}
.osjs-login .osjs-login-field {
  position: relative;
}
.osjs-login input,
.osjs-login select,
.osjs-login button {
  padding: 0.5em;
  display: block;
  width: 100%;
  border-radius: 0;
  border: 0 none;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  box-sizing: border-box;
}
.osjs-login input[type=submit],
.osjs-login button {
  cursor: pointer;
}

#osjs-login {
  font-family: Roboto, sans-serif;
  max-width: 400px;
  width: 80%;
}
#osjs-login .osjs-login-header {
  text-align: center;
  font-weight: 300;
  font-weight: bold;
  font-size: 2em;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 4px;
  line-height: 1.5;
}
#osjs-login .osjs-login-logo {
  min-width: 1em;
  min-height: 1em;
  height: 100%;
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}
#osjs-login .osjs-login-logo[data-position=bottom], #osjs-login .osjs-login-logo[data-position=top], #osjs-login .osjs-login-logo[data-position=middle] {
  min-height: 4em;
}
#osjs-login .osjs-login-logo[data-position=left], #osjs-login .osjs-login-logo[data-position=right] {
  min-width: 4em;
}
#osjs-login .osjs-login-logo[data-position=bottom] {
  margin-top: 2em;
}
#osjs-login > div[data-position=left] {
  margin-right: 2em;
}
#osjs-login > div[data-position=right] {
  margin-left: 2em;
}
#osjs-login .osjs-login-content {
  width: 100%;
  display: flex;
  flex-direction: column;
}
#osjs-login .osjs-login-field {
  margin-top: 2em;
}
#osjs-login .osjs-login-field-select {
  position: relative;
}
#osjs-login .osjs-login-field-select::after {
  content: "↴";
  position: absolute;
  top: 50%;
  right: 0.5em;
  transform: translate(-50%, -50%);
  color: #fff;
}
#osjs-login .osjs-login-error {
  background: rgba(255, 0, 0, 0.8);
  color: #fff;
  text-align: center;
  text-decoration: uppercase;
  padding: 1em;
  margin-top: 2em;
}
#osjs-login .osjs-login-stamp {
  margin-top: 2em;
  font-size: 80%;
  text-align: right;
  color: rgba(255, 255, 255, 0.5);
}
#osjs-login input {
  outline: 1px solid rgba(255, 255, 255, 0.5);
}
#osjs-login input:focus, #osjs-login input:active {
  box-shadow: 0 0 0.5em rgba(255, 255, 255, 0.8);
}
#osjs-login input[type=submit],
#osjs-login button {
  padding: 1em;
  background-color: #fff;
  letter-spacing: 1px;
  text-transform: uppercase;
}
#osjs-login select,
#osjs-login input[type=password],
#osjs-login input[type=text] {
  padding: 1em;
  background: rgba(255, 255, 255, 0.5);
  color: #fff;
  letter-spacing: 1px;
}
#osjs-login select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
#osjs-login select option {
  color: #000;
}
#osjs-login ::-webkit-input-placeholder {
  color: #fff;
  text-transform: uppercase;
  font-family: inherit;
  font-weight: bold;
}
#osjs-login ::-moz-placeholder {
  color: #fff;
  text-transform: uppercase;
  font-family: inherit;
  font-weight: bold;
}
#osjs-login :-ms-input-placeholder {
  color: #fff;
  text-transform: uppercase;
  font-family: inherit;
  font-weight: bold;
}
#osjs-login :-moz-placeholder {
  color: #fff;
  text-transform: uppercase;
  font-family: inherit;
  font-weight: bold;
}

/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
.osjs-search {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1000000000000000000;
  width: 0;
  height: 0;
  overflow: visible;
}

.osjs-search-container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 50vw;
  max-height: 80vh;
  transform: translate(-50%, -50%);
}

.osjs-search-input {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 1em;
}

.osjs-search-message {
  padding: 1em;
}

.osjs-search-results {
  margin: 0;
  padding: 0;
  list-style-type: none;
  overflow-x: hidden;
  overflow-y: scroll;
}

.osjs-search-result {
  padding: 0;
  margin: 1em;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.osjs-search-result img {
  margin-right: 1em;
}

a[eoxapplication] {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/osjs-client/index.scss","webpack://./src/osjs-client/src/styles/_variables.scss","webpack://./src/osjs-client/src/styles/_core.scss","webpack://./src/osjs-client/src/styles/_window.scss","webpack://./src/osjs-client/src/styles/_notifications.scss","webpack://./src/osjs-client/src/styles/_login.scss","webpack://./src/osjs-client/src/styles/_search.scss","webpack://./src/osjs-client/src/styles/coreEOXApplication.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;ACAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;ACAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;AA8BA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4BAAA;EACA,4BAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;AF2DF;AEzDE;EACE,cAAA;AF2DJ;AExDE;;;EAGE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AF0DJ;AEtDI;EACE,oBAAA;AFwDN;;AEnDA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,mBAAA;EACA,2CAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AFsDF;;AEnDA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AFsDF;;AEnDA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;EACA,mBAAA;EACA,2CAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AFsDF;;AEnDA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;AFsDF;;AEnDA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,oBAAA;EACA,0CAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AFsDF;;AEnDA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AFsDF;;AElDE;EACE,YAAA;EACA,yBAAA;EACA,+CAAA;AFqDJ;AEnDI;EACE,YAAA;AFqDN;AElDI;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AFoDN;AEjDI;EACE,qBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AFmDN;AEjDM;EACE,yBAAA;AFmDR;AE/CI;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AFiDN;AE/CM;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AFiDR;AE9CM;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AFgDR;AE9CQ;EACE,eAAA;EACA,cAAA;AFgDV;AE3CI;EACE,yBAAA;EACA,YAAA;AF6CN;AE3CM;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;AF6CR;AE1CM;EACE,kBAAA;EACA,iBAAA;AF4CR;AEzCM;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AF2CR;AEzCQ;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AF2CV;AEvCM;EACE,iBAAA;AFyCR;AEvCQ;EACE,iBAAA;AFyCV;;AG9RA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;AAuCA;EACE,kBAAA;EACA,sBAAA;AHuRF;;AGpRA;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AHuRF;AGrRE;EACE,WAAA;AHuRJ;AGpRE;EACE,cAAA;AHsRJ;AGnRE;EACE,YAAA;AHqRJ;AGlRE;EACE,aAAA;AHoRJ;AGhRI;EACE,iBAAA;AHkRN;AGnRI;EACE,iBAAA;AHqRN;AGtRI;EACE,iBAAA;AHwRN;AGzRI;EACE,iBAAA;AH2RN;AG5RI;EACE,gBAAA;AH8RN;AG/RI;EACE,gBAAA;AHiSN;AGlSI;EACE,gBAAA;AHoSN;AGrSI;EACE,gBAAA;AHuSN;AGnSE;EAEE,WF3CiB;EE4CjB,YF5CiB;ADgVrB;AGjSE;EAEE,UFjDiB;EEkDjB,aFlDiB;ADoVrB;;AG9RA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AHiSF;;AG9RA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AHiSF;AG/RE;EACE,YAAA;EACA,wBAAA;AHiSJ;;AG5RE;EACE,UF/EU;EEgFV,WFhFU;EEiFV,qEAAA;EACA,sBAAA;EACA,eAAA;AH+RJ;;AG3RA;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AH8RF;;AG3RA;EACE,aAAA;EACA,iBAAA;AH8RF;;AG3RA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AH8RF;AG5RE;EACE,oBAAA;AH8RJ;AG3RE;EACE,UF/GU;EEgHV,WFhHU;AD6Yd;AG1RE;EACE,oBAAA;AH4RJ;;AGvRE;EACE,eAAA;EACA,mBAAA;AH0RJ;;AGtRA;EACE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;AHyRF;;AGtRA;EACE,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,wCAAA;EACA,uCAAA;EACA,oCAAA;EACA,+BAAA;EACA,mCAAA;EACA,gCAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;AHwRF;AGtRE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;AHwRJ;AGrRE;EArKA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;AH6bF;AGxRI;EACE,0BAAA;AH0RN;AGtRE;EACE,aAAA;EACA,kBAAA;EACA,wBAAA;AHwRJ;AGrRE;EACE,oBAAA;AHuRJ;AGpRE;EAEE,YAAA;AHqRJ;AGlRE;EACE,cAAA;AHoRJ;AGjRE;EACE,uBAAA;AHmRJ;AGhRE;EAIE,aAAA;AH+QJ;;AG1QE;EACE,kDAAA;AH6QJ;AG5QI;EACE,oBAAA;AH8QN;;AGxQE;EAtNA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EAqNE,UAAA;AH8QJ;AG5QI;EACE,aAAA;AH8QN;;AI1gBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;AA8BA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,oBAAA;EACA,sBAAA;EACA,YHNY;EGOZ,YAAA;EACA,gBAAA;EACA,iBAAA;AJ4gBF;;AIzgBA;EACE,YHbY;EGcZ,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBHjBY;AD6hBd;;AIzgBA;EACE,oBAAA;EACA,4BAAA;AJ4gBF;AI1gBE;EACE,6BAAA;AJ4gBJ;;AKnkBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;AAqCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,gCAAA;EACA,aAAA;AL8jBF;AK5jBE;EACE,kBAAA;AL8jBJ;AK3jBE;;;EAGE,cAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;AL6jBJ;AK1jBE;;EAEE,eAAA;AL4jBJ;;AKxjBA;EACE,+BAAA;EACA,gBAAA;EACA,UAAA;AL2jBF;AKzjBE;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AL2jBJ;AKxjBE;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,4BAAA;EACA,kCAAA;AL0jBJ;AKxjBI;EAGE,eAAA;ALwjBN;AKrjBI;EAEE,cAAA;ALsjBN;AKnjBI;EACE,eAAA;ALqjBN;AKhjBI;EACE,iBAAA;ALkjBN;AK/iBI;EACE,gBAAA;ALijBN;AK7iBE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AL+iBJ;AK5iBE;EACE,eAAA;AL8iBJ;AK3iBE;EACE,kBAAA;AL6iBJ;AK3iBI;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;AL6iBN;AKziBE;EACE,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;EACA,YJtHU;EIuHV,eAAA;AL2iBJ;AKxiBE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,+BAAA;AL0iBJ;AKviBE;EACE,2CAAA;ALyiBJ;AKviBI;EAEE,8CAAA;ALwiBN;AKpiBE;;EAEE,YJ5IU;EI6IV,sBAAA;EACA,mBAAA;EACA,yBAAA;ALsiBJ;AKniBE;;;EAGE,YJrJU;EIsJV,oCAAA;EACA,WAAA;EACA,mBAAA;ALqiBJ;AKliBE;EACE,wBAAA;EACA,qBAAA;EACA,gBAAA;ALoiBJ;AKliBI;EACE,WAAA;ALoiBN;AKhiBE;EApKA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;ALusBF;AKliBE;EAxKA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;AL6sBF;AKpiBE;EA5KA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;ALmtBF;AKtiBE;EAhLA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;ALytBF;;AM3vBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;AA8BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4BAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;AN6vBF;;AM1vBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;AN6vBF;;AM1vBA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EACA,YLvBY;ADoxBd;;AM1vBA;EACE,YL3BY;ADwxBd;;AM1vBA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AN6vBF;;AM1vBA;EACE,UAAA;EACA,WLxCY;EKyCZ,aAAA;EACA,mBAAA;EACA,eAAA;AN6vBF;AM3vBE;EACE,iBL9CU;AD2yBd;;AOz0BA;EACE,eAAA;AP40BF","sourcesContent":["/*!\n * OS.js - JavaScript Cloud/Web Desktop Platform\n *\n * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n *\n * 1. Redistributions of source code must retain the above copyright notice, this\n *    list of conditions and the following disclaimer\n * 2. Redistributions in binary form must reproduce the above copyright notice,\n *    this list of conditions and the following disclaimer in the documentation\n *    and/or other materials provided with the distribution\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND\n * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED\n * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR\n * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES\n * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;\n * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND\n * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS\n * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n *\n * @author  Anders Evenrud <andersevenrud@gmail.com>\n * @licence Simplified BSD License\n */\n\n@import \"./src/styles/variables\";\n@import \"./src/styles/core\";\n@import \"./src/styles/window\";\n@import \"./src/styles/notifications\";\n@import \"./src/styles/login\";\n@import \"./src/styles/search\";\n@import \"./src/styles/coreEOXApplication.scss\";\n","/*\n * OS.js - JavaScript Cloud/Web Desktop Platform\n *\n * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n *\n * 1. Redistributions of source code must retain the above copyright notice, this\n *    list of conditions and the following disclaimer\n * 2. Redistributions in binary form must reproduce the above copyright notice,\n *    this list of conditions and the following disclaimer in the documentation\n *    and/or other materials provided with the distribution\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND\n * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED\n * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR\n * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES\n * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;\n * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND\n * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS\n * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n *\n * @author  Anders Evenrud <andersevenrud@gmail.com>\n * @licence Simplified BSD License\n */\n\n$base-margin: 1em;\n$resize-handle-size: 0.5em;\n","/*\n * OS.js - JavaScript Cloud/Web Desktop Platform\n *\n * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n *\n * 1. Redistributions of source code must retain the above copyright notice, this\n *    list of conditions and the following disclaimer\n * 2. Redistributions in binary form must reproduce the above copyright notice,\n *    this list of conditions and the following disclaimer in the documentation\n *    and/or other materials provided with the distribution\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND\n * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED\n * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR\n * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES\n * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;\n * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND\n * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS\n * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n *\n * @author  Anders Evenrud <andersevenrud@gmail.com>\n * @licence Simplified BSD License\n */\n\n.osjs-root {\n  line-height: 1;\n  font-size: 13px;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-size: cover;\n  background-position: 50% 50%;\n  background-repeat: no-repeat;\n  position: fixed;\n  top: 0;\n  left: 0;\n  touch-action: none;\n\n  &[data-dir=\"rtl\"] {\n    direction: rtl;\n  }\n\n  textarea,\n  input,\n  label {\n    -webkit-user-select: text;\n    -moz-user-select: text;\n    -ms-user-select: text;\n    user-select: text;\n  }\n\n  &[data-mousemove=\"true\"] {\n    iframe {\n      pointer-events: none;\n    }\n  }\n}\n\n.osjs-boot-splash-grid {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 9999999999;\n  background-color: rgba(255, 255, 255, 0.84);\n  height: 100%;\n  width: 100%;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.osjs-boot-splash {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.6);\n  display: flex;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999999999;\n  flex-direction: column;\n}\n\n.osjs-boot-splash-fullscreen {\n  position: absolute;\n  top: 50vh;\n  left: 50vw;\n  transform: translate(-50%, -50%);\n  z-index: 9999999999;\n  background-color: rgba(255, 255, 255, 0.84);\n  height: 100vh;\n  width: 100vw;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.osjs-boot-splash_message {\n  font-size: 20px;\n  color: black;\n  margin-bottom: 3rem;\n}\n\n.osjs-mask-application {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 99999999999;\n  background-color: rgba(255, 255, 255, 0.5);\n  height: 100%;\n  width: 100%;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.osjs-contents {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n}\n\n.osjs-profile-info-popup {\n  .profile-info-popup {\n    width: 280px;\n    z-index: 30000 !important;\n    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n\n    .k-popup {\n      border: none;\n    }\n\n    .text-overflow {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    .close-icon {\n      margin: 10px 15px 0px;\n      display: flex;\n      height: 20px;\n      width: 20px;\n      cursor: pointer;\n      align-items: center;\n      margin-left: auto;\n      border-radius: 50%;\n      justify-content: center;\n\n      &:hover {\n        background-color: #f0f0f0;\n      }\n    }\n\n    .profile-img-container {\n      align-items: center;\n      display: flex;\n      margin-bottom: 12px;\n      justify-content: center;\n\n      .profile-img {\n        height: 120px;\n        width: 120px;\n        border-radius: 50%;\n      }\n\n      .profile-icon {\n        background-color: #E9EBEC;\n        border-radius: 50%;\n        width: 120px;\n        height: 120px;\n        align-items: center;\n        display: flex;\n        justify-content: center;\n\n        .icon {\n          font-size: 80px;\n          color: #B8BFC1;\n        }\n      }\n    }\n\n    .profile-content {\n      background-color: #275362;\n      color: white;\n\n      .name {\n        font-size: 22px;\n        text-align: center;\n        line-height: 35px;\n      }\n\n      .designation {\n        text-align: center;\n        line-height: 25px;\n      }\n\n      .chat-mail-link {\n        height: 60px;\n        align-items: center;\n        display: flex;\n        justify-content: center;\n\n        .link-container {\n          height: 40px;\n          margin: 5px;\n          cursor: pointer;\n          width: 40px;\n          background-color: #efefef;\n          border-radius: 50%;\n          align-items: center;\n          justify-content: center;\n          display: flex;\n        }\n      }\n\n      .other-info {\n        line-height: 30px;\n\n        i {\n          margin-right: 6px;\n        }\n      }\n    }\n  }\n}","/*\n * OS.js - JavaScript Cloud/Web Desktop Platform\n *\n * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n *\n * 1. Redistributions of source code must retain the above copyright notice, this\n *    list of conditions and the following disclaimer\n * 2. Redistributions in binary form must reproduce the above copyright notice,\n *    this list of conditions and the following disclaimer in the documentation\n *    and/or other materials provided with the distribution\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND\n * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED\n * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR\n * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES\n * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;\n * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND\n * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS\n * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n *\n * @author  Anders Evenrud <andersevenrud@gmail.com>\n * @licence Simplified BSD License\n */\n\n$direction-list: \"nw\" \"sw\" \"ne\" \"se\" \"n\" \"s\" \"w\" \"e\";\n\n@mixin osjs-window-maximized {\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.osjs-window-behavior-lofi {\n  position: absolute;\n  border: 2px solid #000;\n}\n\n.osjs-window-resize {\n  z-index: 10;\n  position: absolute;\n  min-width: 4px;\n  min-height: 0.1em;\n\n  &[data-direction^=\"n\"] {\n    top: -$resize-handle-size;\n  }\n\n  &[data-direction^=\"s\"] {\n    bottom: -$resize-handle-size;\n  }\n\n  &[data-direction$=\"w\"] {\n    left: -$resize-handle-size;\n  }\n\n  &[data-direction$=\"e\"] {\n    right: -$resize-handle-size;\n  }\n\n  @each $d in $direction-list {\n    &[data-direction=\"#{$d}\"] {\n      cursor: #{$d}-resize;\n    }\n  }\n\n  &[data-direction=\"s\"],\n  &[data-direction=\"n\"] {\n    left: $resize-handle-size;\n    right: $resize-handle-size;\n  }\n\n  &[data-direction=\"e\"],\n  &[data-direction=\"w\"] {\n    top: $resize-handle-size;\n    bottom: $resize-handle-size;\n  }\n}\n\n.osjs-window-inner {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  height: 100%;\n  width: 100%;\n  flex-direction: column;\n}\n\n.osjs-window-header {\n  display: flex;\n  position: relative;\n  box-sizing: border-box;\n  flex: 0 0;\n  min-height: 2.2em;\n\n  & > div {\n    height: auto;\n    padding: 0px 5px 0px 5px;\n  }\n}\n\n.osjs-window-icon {\n  & > div {\n    width: $base-margin;\n    height: $base-margin;\n    background: url(\"src/styles/logo-blue-32x32.png\") no-repeat 50% 50%;\n    background-size: cover;\n    cursor: pointer;\n  }\n}\n\n.osjs-window-title {\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n}\n\n.osjs-window-manage-buttons {\n  display: flex;\n  margin-right: 3px;\n}\n\n.osjs-window-button {\n  cursor: pointer;\n  min-width: 1em;\n  position: relative;\n  flex-basis: 1em;\n\n  * {\n    pointer-events: none;\n  }\n\n  & > div {\n    width: $base-margin;\n    height: $base-margin;\n  }\n\n  &:not(:last-child) {\n    margin-right: calc($base-margin / 4);\n  }\n}\n\n.osjs-root[data-dir=\"rtl\"] {\n  .osjs-window-button:not(:last-child) {\n    margin-right: 0;\n    margin-left: calc($base-margin / 4);\n  }\n}\n\n.osjs-window-content {\n  box-sizing: border-box;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  flex: 1 1;\n  user-select: text;\n}\n\n.osjs-window {\n  position: absolute;\n  box-sizing: border-box;\n  user-select: none;\n  visibility: visible;\n  touch-action: none;\n\n  /* This actually increases performance */\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -webkit-perspective: 1000;\n  -moz-perspective: 1000;\n  perspective: 1000;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 9999999999;\n    display: none;\n  }\n\n  &[data-maximized=\"true\"] {\n    @include osjs-window-maximized();\n\n    .osjs-window-resize {\n      cursor: inherit !important;\n    }\n  }\n\n  &[data-minimized=\"true\"] {\n    display: none;\n    visibility: hidden;\n    height: 560px !important;\n  }\n\n  &[data-focused=\"false\"] iframe {\n    pointer-events: none;\n  }\n\n  &[data-resizing=\"true\"],\n  &[data-moving=\"true\"] {\n    cursor: move;\n  }\n\n  &[data-loading=\"true\"]::after {\n    display: block;\n  }\n\n  &.osjs__drop {\n    outline: 2px solid #000;\n  }\n\n  &[data-minimizable=\"false\"] .osjs-window-button[data-action=\"minimize\"],\n  &[data-maximizable=\"false\"] .osjs-window-button[data-action=\"maximize\"],\n  &[data-closable=\"false\"] .osjs-window-button[data-action=\"close\"],\n  &[data-resizable=\"false\"] .osjs-window-resize {\n    display: none;\n  }\n}\n\n.osjs-root[data-window-action=\"true\"] {\n  .osjs-window {\n    /* FIXME: Maybe limit this as to increase perf ? */\n    * {\n      pointer-events: none;\n    }\n  }\n}\n\n.osjs-root[data-mobile=\"true\"] {\n  .osjs-window {\n    @include osjs-window-maximized();\n    opacity: 1;\n\n    .osjs-window-button[data-action=\"maximize\"] {\n      display: none;\n    }\n  }\n}\n","/*\n * OS.js - JavaScript Cloud/Web Desktop Platform\n *\n * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n *\n * 1. Redistributions of source code must retain the above copyright notice, this\n *    list of conditions and the following disclaimer\n * 2. Redistributions in binary form must reproduce the above copyright notice,\n *    this list of conditions and the following disclaimer in the documentation\n *    and/or other materials provided with the distribution\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND\n * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED\n * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR\n * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES\n * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;\n * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND\n * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS\n * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n *\n * @author  Anders Evenrud <andersevenrud@gmail.com>\n * @licence Simplified BSD License\n */\n\n.osjs-notifications {\n  position: absolute;\n  top: 0;\n  right: 0;\n  pointer-events: none;\n  box-sizing: border-box;\n  padding: $base-margin;\n  height: 100%;\n  max-height: 100%;\n  z-index: 16777272;\n}\n\n.osjs-notification {\n  padding: $base-margin;\n  box-sizing: border-box;\n  pointer-events: all;\n  min-width: 200px;\n  margin-bottom: $base-margin;\n}\n\n.osjs-notification-wrapper {\n  background-size: 3em;\n  background-repeat: no-repeat;\n\n  &[data-has-icon=true] {\n    padding-left: calc(3em + #{$base-margin});\n  }\n}\n","/*\n * OS.js - JavaScript Cloud/Web Desktop Platform\n *\n * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n *\n * 1. Redistributions of source code must retain the above copyright notice, this\n *    list of conditions and the following disclaimer\n * 2. Redistributions in binary form must reproduce the above copyright notice,\n *    this list of conditions and the following disclaimer in the documentation\n *    and/or other materials provided with the distribution\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND\n * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED\n * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR\n * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES\n * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;\n * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND\n * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS\n * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n *\n * @author  Anders Evenrud <andersevenrud@gmail.com>\n * @licence Simplified BSD License\n */\n\n@mixin placeholder-effect {\n  color: #fff;\n  text-transform: uppercase;\n  font-family: inherit;\n  font-weight: bold;\n}\n\n.osjs-login {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 99999;\n  transform: translate(-50%, -50%);\n  display: flex;\n\n  .osjs-login-field {\n    position: relative;\n  }\n\n  input,\n  select,\n  button {\n    padding: calc($base-margin / 2);\n    display: block;\n    width: 100%;\n    border-radius: 0;\n    border: 0 none;\n    font-family: inherit;\n    font-size: inherit;\n    color: inherit;\n    box-sizing: border-box;\n  }\n\n  input[type=submit],\n  button {\n    cursor: pointer;\n  }\n}\n\n#osjs-login {\n  font-family: Roboto, sans-serif;\n  max-width: 400px;\n  width: 80%;\n\n  .osjs-login-header {\n    text-align: center;\n    font-weight: 300;\n    font-weight: bold;\n    font-size: 2em;\n    text-transform: uppercase;\n    color: #fff;\n    letter-spacing: 4px;\n    line-height: 1.5;\n  }\n\n  .osjs-login-logo {\n    min-width: 1em;\n    min-height: 1em;\n    height: 100%;\n    width: 100%;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center center;\n\n    &[data-position=bottom],\n    &[data-position=top],\n    &[data-position=middle] {\n      min-height: 4em;\n    }\n\n    &[data-position=left],\n    &[data-position=right] {\n      min-width: 4em;\n    }\n\n    &[data-position=bottom] {\n      margin-top: 2em;\n    }\n  }\n\n  & > div {\n    &[data-position=left] {\n      margin-right: 2em;\n    }\n\n    &[data-position=right] {\n      margin-left: 2em;\n    }\n  }\n\n  .osjs-login-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .osjs-login-field {\n    margin-top: $base-margin * 2;\n  }\n\n  .osjs-login-field-select {\n    position: relative;\n\n    &::after {\n      content: '\\21B4';\n      position: absolute;\n      top: 50%;\n      right: calc($base-margin / 2);\n      transform: translate(-50%, -50%);\n      color: #fff;\n    }\n  }\n\n  .osjs-login-error {\n    background: rgba(255, 0, 0, 0.8);\n    color: #fff;\n    text-align: center;\n    text-decoration: uppercase;\n    padding: $base-margin;\n    margin-top: $base-margin * 2;\n  }\n\n  .osjs-login-stamp {\n    margin-top: $base-margin * 2;\n    font-size: 80%;\n    text-align: right;\n    color: rgba(255, 255, 255, 0.5);\n  }\n\n  input {\n    outline: 1px solid rgba(255, 255, 255, 0.5);\n\n    &:focus,\n    &:active {\n      box-shadow: 0 0 0.5em rgba(255, 255, 255, 0.8);\n    }\n  }\n\n  input[type=submit],\n  button {\n    padding: $base-margin;\n    background-color: #fff;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n  }\n\n  select,\n  input[type=password],\n  input[type=text] {\n    padding: $base-margin;\n    background: rgba(255, 255, 255, 0.5);\n    color: #fff;\n    letter-spacing: 1px;\n  }\n\n  select {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n\n    option {\n      color: #000;\n    }\n  }\n\n  ::-webkit-input-placeholder {\n    @include placeholder-effect;\n  }\n\n  ::-moz-placeholder {\n    @include placeholder-effect;\n  }\n\n  :-ms-input-placeholder {\n    @include placeholder-effect;\n  }\n\n  :-moz-placeholder {\n    @include placeholder-effect;\n  }\n}\n","/*\n * OS.js - JavaScript Cloud/Web Desktop Platform\n *\n * Copyright (c) 2011-2019, Anders Evenrud <andersevenrud@gmail.com>\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, are permitted provided that the following conditions are met:\n *\n * 1. Redistributions of source code must retain the above copyright notice, this\n *    list of conditions and the following disclaimer\n * 2. Redistributions in binary form must reproduce the above copyright notice,\n *    this list of conditions and the following disclaimer in the documentation\n *    and/or other materials provided with the distribution\n *\n * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS \"AS IS\" AND\n * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED\n * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE\n * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR\n * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES\n * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;\n * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND\n * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS\n * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n *\n * @author  Anders Evenrud <andersevenrud@gmail.com>\n * @licence Simplified BSD License\n */\n\n.osjs-search {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 999999999999999999;\n  width: 0;\n  height: 0;\n  overflow: visible;\n}\n\n.osjs-search-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 50vw;\n  max-height: 80vh;\n  transform: translate(-50%, -50%);\n}\n\n.osjs-search-input {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  padding: $base-margin;\n}\n\n.osjs-search-message {\n  padding: $base-margin;\n}\n\n.osjs-search-results {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n\n.osjs-search-result {\n  padding: 0;\n  margin: $base-margin;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  img {\n    margin-right: $base-margin;\n  }\n}\n","a[eoxapplication] {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
